// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileMenuItem_container__YwVVa","submenu":"MobileMenuItem_submenu__qGMXa","arrowContainer":"MobileMenuItem_arrowContainer__8CFXB"};